import React from "react";
import "./aboutextra.css";
import {Link} from "react-router-dom";
import { motion } from "framer-motion";

const AboutPage = () => {
  return (
    <div className="about-container">
      {/* Section 1: Hero / Intro */}
      <motion.section
        className="hero-section"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <div className="hero-content">
          <h1>
            About <span>Our Company</span>
          </h1>
          <p>
            Empowering investors through innovation, trust, and transparency.
            We believe in turning financial dreams into lasting success.
          </p>
        </div>
      </motion.section>

      {/* Section 2: Our Story */}
      <motion.section
        className="story-section"
        initial={{ opacity: 0, x: -80 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <div className="story-content">
          <h2>Our Story</h2>
          <p>
            Founded with a vision to redefine ethical investing, our journey began with 
            a simple idea — to make investments accessible, transparent, and impactful. 
            Over the years, we’ve grown into a trusted name, helping thousands of clients 
            achieve financial independence through well-crafted strategies and a commitment to integrity.
          </p>
        </div>
        <img
        
          src="https://i.imgur.com/w9Hr00j.jpeg"
          alt="Our Story"
          className="story-image"
        />
      </motion.section>

      {/* Section 3: Mission & Vision */}
      <motion.section
        className="mission-vision-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <div className="mission-box">
          <h3>Our Mission</h3>
          <p>
            To deliver long-term value and sustainable growth for our clients by 
            combining expertise, integrity, and innovation in every decision we make.
          </p>
        </div>
        <div className="vision-box">
          <h3>Our Vision</h3>
          <p>
            To become a global leader in ethical investments, where every financial 
            decision contributes to both personal prosperity and societal progress.
          </p>
        </div>
      </motion.section>

      {/* Section 4: Core Values */}
      <motion.section
        className="values-section"
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9 }}
        viewport={{ once: true }}
      >
        <h2>Our Core Values</h2>
        <div className="values-grid">
          <div className="value-card">
            <i className="fa-solid fa-handshake"></i>
            <h4>Integrity</h4>
            <p>We maintain honesty and transparency in every relationship we build.</p>
          </div>
          <div className="value-card">
            <i className="fa-solid fa-lightbulb"></i>
            <h4>Innovation</h4>
            <p>We embrace technology and creativity to deliver smarter solutions.</p>
          </div>
          <div className="value-card">
            <i className="fa-solid fa-users"></i>
            <h4>Teamwork</h4>
            <p>We achieve greatness through collaboration and mutual respect.</p>
          </div>
          <div className="value-card">
            <i className="fa-solid fa-globe"></i>
            <h4>Sustainability</h4>
            <p>We believe in building wealth that benefits both people and planet.</p>
          </div>
        </div>
      </motion.section>

      {/* Section 5: Meet the Team */}
      {/*<motion.section
        className="team-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        <h2>Meet Our Leaders</h2>
        <div className="team-cards">
          <div className="team-card">
            <img src="https://i.ibb.co/5L6Q1LW/person1.jpg" alt="CEO" />
            <h3>Rohit Sharma</h3>
            <p>Founder & CEO</p>
          </div>
          <div className="team-card">
            <img src="https://i.ibb.co/7nZ3JpM/person2.jpg" alt="CIO" />
            <h3>Ananya Gupta</h3>
            <p>Chief Investment Officer</p>
          </div>
          <div className="team-card">
            <img src="https://i.ibb.co/hZ9Lpcv/person3.jpg" alt="Finance Director" />
            <h3>Vikram Rao</h3>
            <p>Finance Director</p>
          </div>
          <div className="team-card">
            <img src="https://i.ibb.co/TKxv0db/person4.jpg" alt="Marketing Head" />
            <h3>Meera Iyer</h3>
            <p>Marketing Head</p>
          </div>
        </div>
      </motion.section>*/}

      {/* Section 6: Why Choose Us */}
      <motion.section
        className="choose-section"
        initial={{ opacity: 0, y: 80 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9 }}
        viewport={{ once: true }}
      >
        <h2>Why Choose Us</h2>
        <div className="choose-grid">
          <div className="choose-card">
            <h4>Expert Guidance</h4>
            <p>Our experienced analysts and advisors craft personalized strategies for every client.</p>
          </div>
          <div className="choose-card">
            <h4>Trusted Network</h4>
            <p>We collaborate with top global firms to bring you the best investment opportunities.</p>
          </div>
          <div className="choose-card">
            <h4>Proven Results</h4>
            <p>Our consistent track record speaks for itself — growth, stability, and success.</p>
          </div>
        </div>
      </motion.section>

      {/* Section 7: CTA */}
      <motion.section
        className="cta-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.9 }}
        viewport={{ once: true }}
      >
        <h2>Let’s Grow Together</h2>
        <p>
          Partner with us to experience financial growth rooted in trust, ethics, and innovation.
        </p>
        <a
        href={`https://wa.me/${918885113763}?text=${encodeURIComponent("")}`}
        target="_blank"
        rel="noopener noreferrer"
        title="Chat on WhatsApp"
      ><button style={{margin:20}}>Contact Us</button></a>
      <Link to="/"><button>Back</button></Link>
      </motion.section>
    </div>
  );
};

export default AboutPage;
